
export const sFechaPublicacion = '2023-06-07T12:25:34.9689218-06:00';
export const sVersion = 'vUA0.1.06071225';
            